module.exports = __webpack_public_path__ + "img/usave.cabfb192.svg";